import { Loader } from "@googlemaps/js-api-loader"
const loader = new Loader({
    apiKey: "AIzaSyDAEv8N9EsdR2cS44K9qhB_Ovf7gqq2uDo",
    // version: "weekly",
    // ...additionalOptions,
});

loader.load().then(async () => {
    let mapElement = document.getElementById("map");
    if(typeof(mapElement) != 'undefined' && mapElement != null) {

        const { Map } = await google.maps.importLibrary("maps");
        var MapCategories = {"shopping":true,"entertainment":true,"gastro":true,"banks":true,"transportation":true,"hotels":true,"health":true};
        var isMobileMap = !1;

        (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) && (isMobileMap = !0);

        for (var map, center = {
            category: 99,
            id: 0,
            label_en: "Arena Busuness Campus",
            label_hu: "Arena Busuness Campus",
            latitude: 47.498781,
            longitude: 19.10719
        }, i = 0; i < MapLoacations.length; i++)
            MapLoacations[i].category = parseInt(MapLoacations[i].category),
            MapLoacations[i].id = parseInt(MapLoacations[i].id),
            MapLoacations[i].latitude = parseFloat(MapLoacations[i].latitude),
            MapLoacations[i].longitude = parseFloat(MapLoacations[i].longitude),
            99 === MapLoacations[i].category && (center = MapLoacations[i]);

        var mapZoom = 14,
            lat = center.latitude,
            lng = center.longitude;

        isMobileMap && (mapZoom = 13);

        var infoPopup = null,
            lastPopupId = null;

        function initMap() {
            definePopupClass(),
            map = new google.maps.Map(mapElement, {
                zoom: mapZoom,
                center: {
                    lat: lat,
                    lng: lng
                },
                scrollwheel: !1,
                navigationControl: !1,
                disableDefaultUI: !1,
                scaleControl: !0,
                streetViewControl: !1,
                mapTypeControl: !1,
                mapTypeId: "roadmap",
                styles: mapStyles
            }),
            setMapMarkers()
        }

        var contentString = []
            , infowindow = []
            , markers = []
            , iconBase = "/images/maps/";

        function setMapMarkers() {
            for (var e = 0; e < MapLoacations.length; e++) {
                var a = {
                    lat: MapLoacations[e].latitude,
                    lng: MapLoacations[e].longitude
                }
                    , o = 100 + e
                    , t = {
                    url: iconBase + MapLoacations[e].keyid + ".png",
                    scaledSize: new google.maps.Size(18, 18),
                    anchor: new google.maps.Point(9, 9)
                };
                99 === MapLoacations[e].category && (o = 0,
                    t = {
                        url: iconBase + MapLoacations[e].keyid + ".png",
                        scaledSize: new google.maps.Size(64, 64),
                        anchor: new google.maps.Point(32, 32)
                    }),
                    contentString[MapLoacations[e].id] = '<div class="map-info-window">' + MapLoacations[e].label + "</div>",
                    infowindow[MapLoacations[e].id] = new google.maps.InfoWindow({
                        content: contentString[MapLoacations[e].id]
                    });
                var i = new google.maps.Marker({
                    mapcategory: MapLoacations[e].keyid,
                    id: MapLoacations[e].id,
                    position: a,
                    icon: t,
                    zIndex: o
                });
                i.addListener("click", function (e) {
                    showInfo(this.id)
                }),
                    markers.push(i),
                    i.setMap(map)
            }
        }

        function showInfo(e) {
            infoPopup && (infoPopup.setMap(null),
                infoPopup = null);
            for (var a = null, o = 0; o < MapLoacations.length; o++)
                MapLoacations[o].id === e && (a = MapLoacations[o]);
                lastPopupId === e ? (lastPopupId = null,
                infoPopup = null) : (infoPopup = new Popup(new google.maps.LatLng(a.latitude, a.longitude, e), document.getElementById("mapLabel-" + a.id)),
                lastPopupId = e,
                infoPopup.setMap(map))
        }

        function definePopupClass() {
            const Popup = function (e, a, o) {
                this.position = e,
                    this.infoid = o,
                    a.classList.add("popup-bubble-content");
                var t = document.createElement("div");
                t.classList.add("popup-bubble-anchor");
                var i = a.cloneNode(!0);
                t.appendChild(i),
                    this.anchor = document.createElement("div"),
                    this.anchor.classList.add("popup-tip-anchor"),
                    this.anchor.appendChild(t),
                    this.stopEventPropagation()
            }
                ;
                Popup.prototype = Object.create(google.maps.OverlayView.prototype),
                Popup.prototype.onAdd = function () {
                    this.getPanes().floatPane.appendChild(this.anchor)
                }
                ,
                Popup.prototype.onRemove = function () {
                    this.anchor.parentElement && this.anchor.parentElement.removeChild(this.anchor)
                }
                ,
                Popup.prototype.draw = function () {
                    var e = this.getProjection().fromLatLngToDivPixel(this.position)
                        , a = Math.abs(e.x) < 4e3 && Math.abs(e.y) < 4e3 ? "block" : "none";
                    "block" === a && (this.anchor.style.left = e.x + "px",
                        this.anchor.style.top = e.y + "px"),
                    this.anchor.style.display !== a && (this.anchor.style.display = a)
                }
                ,
                Popup.prototype.stopEventPropagation = function () {
                    var e = this.anchor;
                    e.style.cursor = "auto",
                        ["click", "dblclick", "contextmenu", "wheel", "mousedown", "touchstart", "pointerdown"].forEach(function (a) {
                            e.addEventListener(a, function (e) {
                                e.stopPropagation()
                            })
                        })
                }
        }

        $(document).ready(function () {
            $("input[data-category-map]").change(function (e) {
                var a = $(e.currentTarget).attr("data-category-map")
                    , o = this.checked;
                MapCategories[a] = o;
                    // // console.log("markers", markers);
                for (var t = 0; t < markers.length; t++)
                    MapCategories[markers[t].mapcategory] || "olympia" === markers[t].mapcategory ? markers[t].setMap(map) : markers[t].setMap(null);
                infoPopup && (infoPopup.setMap(null),
                    infoPopup = null,
                    lastPopupId = null)
            })
        });

        initMap();
    };

});

const mapStyles = [
    {
        elementType: "geometry",
        stylers: [{
            color: "#f5f5f5"
        }]
    }, {
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        elementType: "labels.text.fill",
        stylers: [{
            color: "#616161"
        }]
    }, {
        elementType: "labels.text.stroke",
        stylers: [{
            color: "#f5f5f5"
        }]
    }, {
        featureType: "administrative.land_parcel",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#bdbdbd"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{
            color: "#eeeeee"
        }]
    }, {
        featureType: "poi",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#757575"
        }]
    }, {
        featureType: "poi.business",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{
            color: "#e5e5e5"
        }]
    }, {
        featureType: "poi.park",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#9e9e9e"
        }]
    }, {
        featureType: "road",
        elementType: "geometry",
        stylers: [{
            color: "#ffffff"
        }]
    }, {
        featureType: "road",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#757575"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [{
            color: "#dadada"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#616161"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#9e9e9e"
        }]
    }, {
        featureType: "transit",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit.line",
        elementType: "geometry",
        stylers: [{
            color: "#e5e5e5"
        }]
    }, {
        featureType: "transit.station",
        elementType: "geometry",
        stylers: [{
            color: "#eeeeee"
        }]
    }, {
        featureType: "water",
        stylers: [{
            color: "#e4e4e4"
        }]
    }, {
        featureType: "water",
        elementType: "geometry",
        stylers: [{
            color: "#c9c9c9"
        }]
    }, {
        featureType: "water",
        elementType: "geometry.fill",
        stylers: [{
            color: "#00c7dc"
        }]
    }, {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#9e9e9e"
        }]
    }
]
const MapLoacations = [
    {"id":"2","category":"99","label":"Ar\u00e9na Business Campus","latitude":"47.496546","longitude":"19.108674","keyid":"olympia"},
    {"id":"16","category":"3","label":"Ypsilon Caf\u00e9 and Restaurant","latitude":"47.502720","longitude":"19.106951","keyid":"gastro"},
    {"id":"17","category":"3","label":"Pesti Pipi","latitude":"47.500630","longitude":"19.103930","keyid":"gastro"},
    {"id":"18","category":"3","label":"D\u00f6ner Kebab Express","latitude":"47.500610","longitude":"19.108550","keyid":"gastro"},
    {"id":"19","category":"3","label":"Princess","latitude":"47.500630","longitude":"19.103930","keyid":"gastro"},
    {"id":"20","category":"3","label":"Stefano Pizzeria & Salad & Pasta House","latitude":"47.500610","longitude":"19.108549","keyid":"gastro"},
    {"id":"21","category":"3","label":"Tavasz Chinese Buffet","latitude":"47.500560","longitude":"19.109680","keyid":"gastro"},
    {"id":"22","category":"3","label":"Burger King","latitude":"47.508750","longitude":"19.101750","keyid":"gastro"},
    {"id":"23","category":"3","label":"Kis Kapucinus Beer house and Restaurant","latitude":"47.496390","longitude":"19.106890","keyid":"gastro"},
    {"id":"24","category":"3","label":"Achat Bistorante","latitude":"47.490870","longitude":"19.110840","keyid":"gastro"},
    {"id":"25","category":"3","label":"Finom Falat","latitude":"47.492830","longitude":"19.110180","keyid":"gastro"},
    {"id":"26","category":"3","label":"Oregano Restaurant","latitude":"47.500630","longitude":"19.103930","keyid":"gastro"},
    {"id":"27","category":"3","label":"Arena Corner Office Canteen","latitude":"47.499810","longitude":"19.107230","keyid":"gastro"},
    {"id":"28","category":"3","label":"Green Foodbar","latitude":"47.500700","longitude":"19.110920","keyid":"gastro"},
    {"id":"29","category":"3","label":"F\u00e9lid\u0151","latitude":"47.508200","longitude":"19.104090","keyid":"gastro"},
    {"id":"30","category":"3","label":"Teri presso","latitude":"47.500620","longitude":"19.110230","keyid":"gastro"},
    {"id":"31","category":"3","label":"R\u00e9teskuck\u00f3","latitude":"47.500780","longitude":"19.107960","keyid":"gastro"},
    {"id":"32","category":"3","label":"Grillcsirk\u00e9s","latitude":"47.508200","longitude":"19.104090","keyid":"gastro"},
    {"id":"33","category":"6","label":"BENU Pharmacy","latitude":"47.501340","longitude":"19.107600","keyid":"health"},
    {"id":"34","category":"6","label":"BENU Pharmacy","latitude":"47.500460","longitude":"19.108730","keyid":"health"},
    {"id":"35","category":"6","label":"Broadway Dance Center Dance Studio","latitude":"47.500490","longitude":"19.109020","keyid":"health"},
    {"id":"36","category":"101","label":"OTP Bank ATM","latitude":"47.501340","longitude":"19.107600","keyid":"banks"},
    {"id":"37","category":"3","label":"Nasi Pl\u00e1za","latitude":"47.500724","longitude":"19.107577","keyid":"gastro"},
    {"id":"38","category":"3","label":"Retro Restaurant and Pizzeria","latitude":"47.500610","longitude":"19.108550","keyid":"gastro"},
    {"id":"39","category":"3","label":"Terrace Cafe Food and Drink","latitude":"47.505830","longitude":"19.102530","keyid":"gastro"},
    {"id":"40","category":"101","label":"Unicredti ATM","latitude":"47.497230","longitude":"19.102470","keyid":"banks"},
    {"id":"41","category":"101","label":"Unicredti ATM","latitude":"47.503380","longitude":"19.118990","keyid":"banks"},
    {"id":"42","category":"101","label":"Budapest Bank ATM","latitude":"47.499680","longitude":"19.108220","keyid":"banks"},
    {"id":"43","category":"101","label":"Budapest Bank Account","latitude":"47.510270","longitude":"19.130800","keyid":"banks"},
    {"id":"44","category":"101","label":"Erste Bank Account","latitude":"47.455340","longitude":"19.117550","keyid":"banks"},
    {"id":"45","category":"101","label":"OTP Bank Account","latitude":"47.483380","longitude":"19.104530","keyid":"banks"},
    {"id":"46","category":"101","label":"OTP Bank ATM","latitude":"47.503380","longitude":"19.118990","keyid":"banks"},
    {"id":"47","category":"101","label":"Raiffeisen Bank Account","latitude":"47.499680","longitude":"19.108219","keyid":"banks"},
    {"id":"48","category":"101","label":"MKB Bank Account","latitude":"47.510460","longitude":"19.099740","keyid":"banks"},
    {"id":"49","category":"6","label":"Ciprus Hung\u00e1ria Pharmacy","latitude":"47.493130","longitude":"19.108660","keyid":"health"},
    {"id":"50","category":"6","label":"Egressy Pharmacy","latitude":"47.506460","longitude":"19.103930","keyid":"health"},
    {"id":"51","category":"6","label":"Honv\u00e9d Zr\u00ednyi SE. Kyokushin Karate Section","latitude":"47.492110","longitude":"19.110180","keyid":"health"},
    {"id":"52","category":"6","label":"Curves","latitude":"47.512090","longitude":"19.097690","keyid":"health"},
    {"id":"53","category":"6","label":"Gilda Max Hermina","latitude":"47.514190","longitude":"19.094660","keyid":"health"},
    {"id":"54","category":"6","label":"BKV El\u0151re Sport Club","latitude":"47.491750","longitude":"19.107010","keyid":"health"},
    {"id":"55","category":"1","label":"Arena Mall","latitude":"47.499310","longitude":"19.090710","keyid":"shopping"},
    {"id":"56","category":"1","label":"Post office","latitude":"47.512090","longitude":"19.097950","keyid":"shopping"},
    {"id":"57","category":"1","label":"Tesco","latitude":"47.504480","longitude":"19.116640","keyid":"shopping"},
    {"id":"58","category":"1","label":"Penny Market","latitude":"47.495950","longitude":"19.107660","keyid":"shopping"},
    {"id":"59","category":"1","label":"Lidl","latitude":"47.495340","longitude":"19.108700","keyid":"shopping"},
    {"id":"60","category":"1","label":"Herbah\u00e1z","latitude":"47.495190","longitude":"19.107520","keyid":"shopping"},
    {"id":"61","category":"5","label":"ACHAT Premium Budapest","latitude":"47.490871","longitude":"19.110840","keyid":"hotels"},
    {"id":"62","category":"5","label":"Expo Congress Hotel","latitude":"47.495380","longitude":"19.118980","keyid":"hotels"},
    {"id":"63","category":"5","label":"Green Hotel Budapest","latitude":"47.500450","longitude":"19.110500","keyid":"hotels"},
    {"id":"64","category":"5","label":"Danubius Hotel Arena","latitude":"47.499720","longitude":"19.103620","keyid":"hotels"},
    {"id":"65","category":"4","label":"Bus Nr.908, 918, 934 ","latitude":"47.496778","longitude":"19.109125","keyid":"transportation"},
    {"id":"66","category":"4","label":"Tram Nr.1, H\u0151s utca","latitude":"47.496183","longitude":"19.109119","keyid":"transportation"},
    {"id":"67","category":"2","label":"Cinema","latitude":"47.498046","longitude":"19.089958","keyid":"entertainment"},
    {"id":"68","category":"2","label":"Papp L\u00e1szl\u00f3 Sportar\u00e9na","latitude":"47.501776","longitude":"19.105535","keyid":"entertainment"},
    {"id":"69","category":"2","label":"Pusk\u00e1s Ferenc Stadium","latitude":"47.503053","longitude":"19.098087","keyid":"entertainment"},
    {"id":"70","category":"4","label":"Metro2 - Pusk\u00e1s Ferenc Stadion","latitude":"47.500279","longitude":"19.106235","keyid":"transportation"},
    {"id":"71","category":"4","label":"Troli Nr.80, 80A","latitude":"47.500112","longitude":"19.107935","keyid":"transportation"},
    {"id":"72","category":"4","label":"Bus Nr.95, 130, 195","latitude":"47.500228","longitude":"19.108541","keyid":"transportation"},
    {"id":"73","category":"4","label":"Tram Nr.1, Pusk\u00e1s Ferenc Stadion","latitude":"47.50088","longitude":"19.108078","keyid":"transportation"}
];
